import React, { useEffect, useState } from 'react';
import api from '../api';

export default function DnsZones() {
  const [doms, setDoms] = useState([]);
  const [sel, setSel] = useState('');
  const [content, setContent] = useState('');
  const [record, setRecord] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => { api.get('/domains').then(r => setDoms(r.data.filter(d => d.has_dns))); }, []);
  useEffect(() => { if (sel) api.get(`/dns/${sel}/records`).then(r => setContent(r.data.content)); }, [sel]);

  const add = async () => {
    setMsg('');
    try {
      await api.post(`/dns/${sel}/records`, { record });
      setRecord(''); setMsg('Registro adicionado.');
      const r = await api.get(`/dns/${sel}/records`); setContent(r.data.content);
    } catch (e) { setMsg(e.response?.data?.error || 'Erro'); }
  };

  return (
    <>
      <div className="page-title"><h1>DNS · Zonas</h1></div>
      <label>Domínio</label>
      <select value={sel} onChange={e => setSel(e.target.value)}>
        <option value="">— escolha —</option>
        {doms.map(d => <option key={d.id} value={d.name}>{d.name}</option>)}
      </select>

      {sel && (
        <>
          <h3 style={{marginTop:'1.5rem'}}>Arquivo de zona</h3>
          <pre className="code">{content || '(vazio)'}</pre>

          <h3 style={{marginTop:'1.5rem'}}>Adicionar registro</h3>
          <input value={record} onChange={e=>setRecord(e.target.value)} placeholder='Ex: vpn  IN  A  1.2.3.4' style={{fontFamily:'JetBrains Mono'}} />
          <div style={{marginTop:'.6rem'}}>
            <button onClick={add} disabled={!record}>Adicionar</button>
            {msg && <span style={{marginLeft:'1rem', color: msg.includes('Erro') ? '#ef4444':'#10b981'}}>{msg}</span>}
          </div>
        </>
      )}
    </>
  );
}
